class SelfAdjustingTimer {
    constructor(interval_seconds, callback) {
        this.target = performance.now();
        this.interval = interval_seconds * 1000;
        this.callback = callback;
        this.stopped = false;
        this.frame = 0;

        this.tick(this);
    }

    tick(self) {
        if (self.stopped) {
            return;
        }

        const currentTime = performance.now();
        const currentTarget = self.target;
        const currentInterval = (self.target += self.interval) - currentTime;

        setTimeout(self.tick, currentInterval, self);
        self.callback(self.frame++, currentTime, currentTarget, self);
    }

    stop() {
        this.stopped = true;

        return this.frame;
    }

    adapt(interval_seconds) {
        this.interval = interval_seconds * 1000;
    }

    redefine(replacement) {
        this.callback = replacement;
    }
}

export { SelfAdjustingTimer };
